<template>
  <div class="gd-page">
    <LoadingOverlay v-if="!rendered" />

    <ClientePerfil
      v-if="rendered && verPerfil"
      :dados-cliente-selecionado="dadosClienteSelecionado"
      :restaurantes="restaurantes"
      @voltar="verPerfil = false"
    />

    <template v-else-if="rendered">
      <DescontosPainel
        :total="pagination.total"
        :restaurantes="restaurantes"
        :search.sync="search"
        :active-tier.sync="activeTier"
        :all-page-selected="allPageSelected"
        :some-page-selected="somePageSelected"
        :total-selected="totalSelected"
        :loading-select-all="loadingSelectAll"
        :bulk-desconto.sync="bulkDesconto"
        :bulk-restaurantes.sync="bulkRestaurantes"
        @toggle-page-select="togglePageSelect"
        @select-all-filtered="selectAllFiltered"
        @clear-selection="clearSelection"
        @confirmar-bulk="showConfirm = true"
        @open-historico="openHistorico"
      />

      <div class="gd-content">
        <DescontosTabela
          :rows="tableData"
          :restaurantes="restaurantes"
          :selected-ids="selectedIds"
          :selected-all-mode="selectedAllMode"
          :all-page-selected="allPageSelected"
          :some-page-selected="somePageSelected"
          :total-selected="totalSelected"
          :sort-rest-id.sync="sortRestId"
          :sort-order.sync="sortOrder"
          :has-filters="!!(search || activeTier)"
          :page="pagination.page"
          :per-page.sync="pagination.perPage"
          :total="pagination.total"
          @toggle-row="toggleRow"
          @toggle-page-select="togglePageSelect"
          @ver-perfil="verPerfilCliente"
          @clear-filters="clearAllFilters"
          @row-updated="onRowUpdated"
          @page-changed="pageChanged"
          @update:perPage="perPageChanged"
        />
      </div>

      <DescontosModais
        :show-confirm.sync="showConfirm"
        :bulk-desconto="bulkDesconto"
        :bulk-restaurantes="bulkRestaurantes"
        :total-selected="totalSelected"
        :bulk-progress="bulkProgress"
        :show-historico.sync="showHistorico"
        :bulks="bulks"
        :show-erros.sync="showErros"
        :erros="bulkErros"
        :erros-bulk-id="errosBulkId"
        @do-bulk="doBulkUpdate"
        @close-progress="bulkProgress.visible = false"
        @ver-erros="openErros"
      />
    </template>
  </div>
</template>

<script>
import LoadingOverlay  from "@/components/Loading/LoadingOverlay";
import ClientePerfil   from "../ClientePerfil.vue";
import DescontosPainel from "./DescontosPainel.vue";
import DescontosTabela from "./DescontosTabela.vue";
import DescontosModais from "./DescontosModais.vue";
import { descontosApi } from "./descontos.api.js";

export default {
  name: "GestorDescontos",
  components: { LoadingOverlay, ClientePerfil, DescontosPainel, DescontosTabela, DescontosModais },

  data() {
    return {
      rendered: false,
      tableData: [], restaurantes: [],
      search: "", activeTier: null, searchTimer: null,
      sortRestId: null, sortOrder: null,
      selectedIds: new Set(), selectedQrMap: {}, selectedAllMode: false,
      allFilteredQrs: [], loadingSelectAll: false,
      bulkDesconto: null, bulkRestaurantes: [], showConfirm: false,
      verPerfil: false, dadosClienteSelecionado: null,
      pagination: { page: 1, perPage: 20, total: 0 },
      bulkProgress: { visible: false, bulkId: null, percent: 0, status: "pendente", processados: 0, total: 0, sucessos: 0, erros: 0, message: "" },
      bulkPollingInterval: null,
      showHistorico: false, bulks: [],
      showErros: false, bulkErros: [], errosBulkId: null,
    };
  },

  computed: {
    allPageSelected() {
      if (this.selectedAllMode) return true;
      return this.tableData.length > 0 && this.tableData.every(r => this.selectedIds.has(r.id));
    },
    somePageSelected() {
      if (this.selectedAllMode) return false;
      return !this.allPageSelected && this.tableData.some(r => this.selectedIds.has(r.id));
    },
    totalSelected() {
      return this.selectedAllMode ? this.pagination.total : this.selectedIds.size;
    },
  },

  watch: {
    search()     { this.onSearchInput(); },
    activeTier() { this.pagination.page = 1; this.carregarDados(); },
    sortRestId() { this.pagination.page = 1; this.carregarDados(); },
    sortOrder()  { this.pagination.page = 1; this.carregarDados(); },
  },

  methods: {
    async carregarDados() {
      try {
        const data = await descontosApi.getMatriz({
          page: this.pagination.page, perPage: this.pagination.perPage,
          search: this.search || undefined, filterTier: this.activeTier || undefined,
          sortRestaurante: this.sortRestId || undefined, sortOrder: this.sortOrder || undefined,
        });
        this.tableData = data.clientes || [];
        this.restaurantes = data.restaurantes || [];
        this.pagination.total = data.pagination?.total || 0;
      } catch { this.$notify({ type: "danger", title: "Erro", message: "Não foi possível carregar dados" }); }
    },
    onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => { this.pagination.page = 1; this.carregarDados(); }, 300);
    },
    clearAllFilters() { this.search = ""; this.activeTier = null; this.pagination.page = 1; this.carregarDados(); },
    pageChanged(p)    { this.pagination.page = p; this.carregarDados(); },
    perPageChanged(v) { this.pagination.perPage = v; this.pagination.page = 1; this.carregarDados(); },

    toggleRow(row) {
      if (this.selectedAllMode) {
        this.selectedAllMode = false; this.allFilteredQrs = [];
        const s = new Set(this.tableData.map(r => r.id)); s.delete(row.id);
        const m = {}; this.tableData.filter(r => s.has(r.id)).forEach(r => { m[r.id] = r.qr_code; });
        this.selectedIds = s; this.selectedQrMap = m; return;
      }
      const s = new Set(this.selectedIds), m = { ...this.selectedQrMap };
      if (s.has(row.id)) { s.delete(row.id); delete m[row.id]; }
      else               { s.add(row.id);    m[row.id] = row.qr_code; }
      this.selectedIds = s; this.selectedQrMap = m;
    },
    togglePageSelect() {
      this.selectedAllMode = false; this.allFilteredQrs = [];
      const s = new Set(this.selectedIds), m = { ...this.selectedQrMap };
      if (this.allPageSelected) { this.tableData.forEach(r => { s.delete(r.id); delete m[r.id]; }); }
      else                      { this.tableData.forEach(r => { s.add(r.id); m[r.id] = r.qr_code; }); }
      this.selectedIds = s; this.selectedQrMap = m;
    },
    async selectAllFiltered() {
      this.loadingSelectAll = true;
      try {
        const data = await descontosApi.getMatriz({ page: 1, perPage: 99999, search: this.search || undefined, filterTier: this.activeTier || undefined });
        this.allFilteredQrs = (data.clientes || []).map(c => String(c.qr_code || "").trim()).filter(Boolean);
        this.selectedAllMode = true;
        this.selectedIds = new Set(this.tableData.map(r => r.id));
      } catch { this.$notify({ type: "danger", title: "Erro", message: "Não foi possível selecionar todos" }); }
      finally { this.loadingSelectAll = false; }
    },
    clearSelection() { this.selectedIds = new Set(); this.selectedQrMap = {}; this.selectedAllMode = false; this.allFilteredQrs = []; },
    async verPerfilCliente(row) {
      try { const data = await descontosApi.getPerfil(row.qr_code); this.dadosClienteSelecionado = data; this.verPerfil = true; }
      catch { this.$notify({ type: "danger", title: "Erro", message: "Falha ao carregar perfil" }); }
    },
    onRowUpdated({ rowId, restId, value }) {
      const row = this.tableData.find(r => r.id === rowId);
      if (row) this.$set(row.descontos, restId, value);
    },
    async doBulkUpdate() {
      this.showConfirm = false;
      const desconto = Number(this.bulkDesconto);
      const qrCodes  = this.selectedAllMode ? this.allFilteredQrs : Object.values(this.selectedQrMap).filter(Boolean);
      if (!qrCodes.length) return;
      const restauranteIds = this.bulkRestaurantes.length ? this.bulkRestaurantes : this.restaurantes.map(r => r.id);
      try {
        const data = await descontosApi.iniciarBulk(desconto, qrCodes, restauranteIds);
        localStorage.setItem("lastBulkId", data.bulk_id);
        this.bulkProgress = { visible: true, bulkId: data.bulk_id, percent: 0, status: "pendente", processados: 0, total: 0, sucessos: 0, erros: 0, message: "A iniciar..." };
        this.startBulkPolling(data.bulk_id);
        this.clearSelection();
      } catch { this.$notify({ type: "danger", title: "Erro", message: "Falha ao iniciar bulk" }); }
      finally { this.bulkDesconto = null; this.bulkRestaurantes = []; }
    },
    startBulkPolling(bulkId) {
      if (this.bulkPollingInterval) clearInterval(this.bulkPollingInterval);
      this.bulkPollingInterval = setInterval(async () => {
        try {
          const data = await descontosApi.getBulkStatus(bulkId);
          Object.assign(this.bulkProgress, { processados: data.processados || 0, total: data.total || 0, sucessos: data.sucessos || 0, erros: data.erros || 0, status: data.status || "desconhecido", percent: data.total ? Math.min(100, Math.round((data.processados/data.total)*100)) : 0 });
          if (data.status === "a_processar") this.bulkProgress.message = `A processar... (${data.sucessos} ok / ${data.erros} erros)`;
          else if (data.status === "concluído") this.bulkProgress.message = `Concluído! ${data.sucessos} sucessos / ${data.erros} falhas`;
          else if (data.status === "falhou") this.bulkProgress.message = "Processo terminou com falha";
          if (["concluído","falhou"].includes(data.status)) {
            clearInterval(this.bulkPollingInterval); this.bulkPollingInterval = null;
            if (data.erros === 0) await this.carregarDados();
            setTimeout(() => (this.bulkProgress.visible = false), 5000);
          }
        } catch { clearInterval(this.bulkPollingInterval); this.bulkPollingInterval = null; this.bulkProgress.visible = false; this.$notify({ type: "danger", title: "Erro", message: "Falha no acompanhamento" }); }
      }, 4000);
    },
    async openHistorico() {
      try { const data = await descontosApi.listarBulks(); this.bulks = data.sort((a,b) => b.id - a.id); this.showHistorico = true; }
      catch { this.$notify({ type: "danger", title: "Erro", message: "Falha ao carregar bulks" }); }
    },
    async openErros(bulkId) {
      try { const data = await descontosApi.getBulkErros(bulkId); this.bulkErros = data.filter(i => i.status === "erro"); this.errosBulkId = bulkId; this.showErros = true; }
      catch { this.$notify({ type: "danger", title: "Erro", message: "Falha ao carregar erros" }); }
    },
  },

  async mounted() { await this.carregarDados(); this.rendered = true; },
  beforeDestroy() {
    if (this.bulkPollingInterval) clearInterval(this.bulkPollingInterval);
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
};
</script>

<style scoped>
.gd-page {
  min-height: 100vh;
  background: #f9f7f6;
  font-family: 'Plus Jakarta Sans','Outfit','DM Sans',system-ui,sans-serif;
}

.gd-content {
  margin: 20px 28px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #f0eeed;
  box-shadow: 0 1px 4px rgba(0,0,0,.04), 0 4px 16px rgba(0,0,0,.04);
  overflow: hidden;
}
</style>
